<template>
  <a
    href="https://baserow.io"
    target="_blank"
    :title="$t('efyLocale.brandDatabase')"
  >
    <Logo
      height="14"
      :alt="$t('efyLocale.brandDatabase')"
    />
  </a>
</template>

<script>
export default {
  name: 'ExternalLinkBaserowLogo',
}
</script>
